export default "__VITE_ASSET__tIKs$Tec__"